export interface AddressV1 {
  addressLineOne: string;
  addressLineTwo: string | null;
  city: string;
  state: string;
  zip: string;
}

export interface EstablishmentV1 {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  imageUrl: string | null;
  secondaryEmail?: string | null;
  secondaryPhone?: string | null;
  address?: AddressV1 | null;
  taxId?: string | null;
  fulfillmentTypes?: string[];
}

export enum ProducerStatus {
  Deactivated = 'Deactivated',
  Lead = 'Lead',
  Pending = 'Pending',
  Ready = 'Ready',
  Active = 'Active',
  Suspended = 'Suspended'
}

export interface ProducerV1 {
  id: string;
  name: string;
  status: ProducerStatus;
  url: string | null;
  imageUrl: string | null;
  phone: string | null;
  email: string;
  marketingBlurb: string | null;
  createdOn: string;
  modifiedOn: string | null;
  establishments: EstablishmentV1[];
  secondaryEmail?: string | null;
  secondaryPhone?: string | null;
  address?: AddressV1 | null;
  businessTypes?: string[];
}

export interface ProducerAdminListQuery {
  pageNum?: number;
  pageSize?: number;
  search?: string;
  sort?: string;
  status?: ProducerStatus;
}
